export const email = (val) => {
  let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(val);
};

export const name = (val) => {
  let re = /^[a-zA-ZÀ-ÿū ]{1,30}$/;
  return re.test(val);
};

export const required = (val) => {
  if (typeof val !== "string") {
    return false;
  }

  return val.trim() !== "";
};

export const number = (val) => {
  let re = /^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/;
  return re.test(val);
};

export const ip = (val) => {
  let re = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return re.test(val);
};

export const subnetRange = (val) => {
  // 1.1.1.1/27 or 1.1.1.1-1.1.1.3
  let re = /^((\b|\.)(0|1|2(?!5(?=6|7|8|9)|6|7|8|9))?\d{1,2}){4}(-((\b|\.)(0|1|2(?!5(?=6|7|8|9)|6|7|8|9))?\d{1,2}){4}|\/((0|1|2|3(?=1|2))\d|\d))\b$/;

  // 1.1.x.x
  let re2 = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|x)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|x)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|x)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|x)$/;

  return re.test(val) || re2.test(val);
};

export const phone = (val) => {
  // let re = /^([0|\+[0-9]{1,5})?([7-9][0-9]{7})$/;
  let re = /^([0|\+[0-9]{7,15})$/;
  return re.test(val);
};

export const url = (str) => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};
